export default interface SettingsState {
    apiVersion: string
    ommitedServicesInOuttime: string[]
    reportOuttimeAgeWarn: number
    reportOuttimeAgeAlert: number
}

export const getDefaultSettingsState = (): SettingsState => {
    return {
        apiVersion: '1.0.0.0',
        ommitedServicesInOuttime: [],
        reportOuttimeAgeWarn: 1,
        reportOuttimeAgeAlert: 2
    }
}
